export default "__VITE_ASSET__WTX1YXFJ__"